<template>
  <div class="content_box UBO">
    <Header @onSearch="onSearch" style="background: #603c2c">
      <!-- 工具栏 -->
      <Tollbar
        :list="tollbarList"
        :moreTool="moreToolbarList"
        type="1"
        theme="1"
        isFilterDis
      ></Tollbar>
    </Header>
    <div class="content_wrap detail">
      <div class="detail_header">
        <div class="detail_header_info">
          <div class="detail_header_info_name">
            {{ companyInfo == null ? "" : companyInfo?.base?.companyName }}
            <!-- <OverflowTooltip :tip="companyInfo?.base?.companyName" /> -->
            <i
              v-if="companyInfo?.base?.collectIds != '-'"
              class="iconfont icon-shoucang active"
            ></i>
          </div>
          <div
            class="detail_header_info_address"
            v-if="
              companyInfo?.base?.durant != '-' || companyInfo?.base?.city != '-'
            "
          >
            <img :src="companyInfo?.base?.img" />
            <div class="detail_header_info_address_txt">
              <span v-if="companyInfo?.base?.durant != '-'">{{
                companyInfo?.base?.durant
              }}</span
              ><span
                v-if="
                  companyInfo?.base?.city != '-' &&
                  companyInfo?.base?.durant != '-'
                "
                >&nbsp;,&nbsp;</span
              ><span v-if="companyInfo?.base?.city != '-'">{{
                companyInfo?.base?.city
              }}</span>
              <span v-if="companyInfo?.base?.province != '-'">
                , {{ companyInfo?.base?.province }}</span
              >
              <span v-if="companyInfo?.base?.country != '-'">
                , {{ companyInfo?.base?.country }}</span
              >
            </div>
          </div>

          <el-tabs class="detail_header_info_label" v-model="activeLabelTab">
            <el-tab-pane
              :key="index"
              v-for="(item, index) in companyInfo?.labels"
              :label="item.label"
              :name="item.label"
              :disabled="true"
            >
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="detail_header_dqi">
          <!-- echart -->
          <div class="new-content-top-right">
            <div class="new-content-right-company">
              <div ref="companyRef" class="new-content-right-echart"></div>
              <div class="new-content-right-title">
                {{ $t("Snapshot.CompanyDQI") }}
                <el-tooltip
                  class="item"
                  popper-class="detail-dqi-tips"
                  effect="light"
                  placement="bottom"
                >
                  <div slot="content">
                    <div class="detail-dqi-tips-header">
                      {{ $t("Snapshot.CompanyDQI") }}
                    </div>
                    <div class="detail-dqi-tips-desc detail-dqi-tips-sub-desc">
                      {{ $t("Snapshot.CompanyTitle") }}
                    </div>
                    <div class="detail-dqi-tips-desc">
                      {{ $t("Snapshot.CompanyDQIdesc1") }}
                    </div>
                    <div class="detail-dqi-tips-desc">
                      {{ $t("Snapshot.CompanyDQIdesc2") }}
                    </div>
                    <div class="detail-dqi-tips-desc">
                      {{ $t("Snapshot.CompanyDQIdesc3") }}
                    </div>
                  </div>
                  <i class="iconfont icon-gantanhao1"></i>
                </el-tooltip>
              </div>
            </div>
            <div class="new-content-right-country">
              <div ref="countryRef" class="new-content-right-echart"></div>
              <div class="new-content-right-title">
                {{ $t("Snapshot.CountryDQI") }}
                <el-tooltip
                  class="item"
                  popper-class="detail-dqi-tips"
                  effect="light"
                  placement="bottom"
                >
                  <div slot="content">
                    <div class="detail-dqi-tips-header">
                      {{ $t("Snapshot.CountryDQI") }}
                    </div>
                    <div class="detail-dqi-tips-desc detail-dqi-tips-sub-desc">
                      {{ $t("Snapshot.CountryTitle") }}
                    </div>
                    <div class="detail-dqi-tips-desc">
                      {{ $t("Snapshot.CountryDQIdesc1") }}
                    </div>
                    <div class="detail-dqi-tips-desc">
                      {{ $t("Snapshot.CountryDQIdesc2") }}
                    </div>
                  </div>
                  <i class="iconfont icon-gantanhao1"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="detail_content">
        <div class="detail_content_tab">
          <div
            class="detail_tab_item"
            :class="{ active: activeTab == tabItem.type }"
            v-for="tabItem in detailTabs"
            v-show="tabItem.isShow"
            :key="tabItem.type"
            @click="changeTab(tabItem.type)"
          >
            {{ tabItem.name }}
          </div>
        </div>
        <div style="position: relative">
          <Background
            class="detail_content_tab_con_desc"
            v-if="activeTab == '1'"
            :detailInfo="companyInfo"
            @showInquiry="isShowInquiry = true"
          />
          <Ownership
            class="detail_content_tab_con_echart"
            v-if="activeTab == '2'"
            @showInquiry="isShowInquiry = true"
          />
          <Investments
            class="detail_content_tab_con_echart"
            v-if="activeTab == '3'"
            @showInquiry="isShowInquiry = true"
          />
          <RelatedCompanies
            class="detail_content_tab_con_echart"
            v-if="activeTab == '4'"
            @showInquiry="isShowInquiry = true"
          />
          <Management
            class="detail_content_tab_con_echart"
            v-if="activeTab == '5'"
          />
          <SupplyChain
            class="detail_content_tab_con_echart"
            v-if="activeTab == '6'"
            :detailInfo="companyInfo"
            @showInquiry="isShowInquiry = true"
          />
          <UboRuler
            class="detail_content_tab_con_echart"
            v-if="activeTab == '7'"
          />
          <InquiryDialog
            :dialogVisible="isShowInquiry"
            :type="activeTab"
            :name="companyInfo?.base?.companyName"
            @closeDialog="isShowInquiry = false"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mixins1 } from "@/mixins/index";
import * as echarts from "echarts/core";
import Page from "@/views/newLayout/page.vue";
import TabIcon from "@/views/newLayout/tabIcon.vue";
import Header from "@/views/newLayout/header.vue";
import Tollbar from "@/views/newLayout/tollbar.vue";
import InquiryDialog from "./Com_Inquiry-dialog.vue";

import Background from "./detail_background.vue";
import Ownership from "./detail_ownership.vue";
import Investments from "./detail_investments.vue";
import RelatedCompanies from "./detail_relatedCompanies.vue";
import Management from "./detail_management.vue";
import SupplyChain from "./detail_supplyChain.vue";
import UboRuler from "./detail_uboRuler.vue";
import { getTabListOneLayer } from "@/api/userApi";
import {
  getSanctionDateSanction,
  getSanctionProfileNotes,
  getSanctionDetailSource,
  getSanctionRelateInfo,
} from "@/api/newApi.js";
import { getCompanySnap, getCompanyProfile } from "@/api/companyApi";

export default {
  name: "UboDetail",
  mixins: [mixins1],
  directives: {
    loadmore: {
      bind(el, binding) {
        const selectWrap = el.querySelector(".el-table__body-wrapper");
        selectWrap.addEventListener("scroll", function () {
          const scrollDistance =
            this.scrollHeight - this.scrollTop - this.clientHeight;
          if (scrollDistance <= 0.5) {
            binding.value(); // 执行绑定的函数
          }
        });
      },
    },
  },
  computed: {
     tollbarList() {
      return [
        {
          icon: "icon-xuanze",
          name: this.$t("Toolbar.Select"),
          disabled: false,
        },
        {
          icon: "icon-bianji1",
          name: this.$t("Toolbar.Edit"),
          disabled: true,
          select: true,
        },
        {
          icon: "icon-filter",
          name: this.$t("Toolbar.Sortby"),
          disabled: true,
          select: true,
        },
        {
          icon: "icon-shoucang1",
          name: this.$t("Toolbar.Collect"),
          disabled: true,
          select: true,
        },
        {
          icon: "icon-baocun",
          name: this.$t("Toolbar.Saved"),
          disabled: true,
          select: true,
        },
        {
          icon: "icon-icon_xinyong_xianxing_jijin-307",
          name: this.$t("Toolbar.Compare"),
          disabled: true,
        },
        {
          icon: "icon-daochu04",
          name: this.$t("Toolbar.Export"),
          disabled: true,
        },
        {
          icon: "icon-xiazai",
          name: this.$t("Toolbar.Download"),
          disabled: true,
        },
        {
          icon: "icon-shuaxin",
          name: this.$t("Toolbar.Update"),
          disabled: true,
        },
        {
          icon: "icon-judan",
          name: this.$t("Toolbar.Reporterror"),
          disabled: true,
        },
        {
          icon: "icon-saomiao",
          name: this.$t("Toolbar.RiskScanning"),
          disabled: true,
        },
      ];
    },
    moreToolbarList() {
      return [
        {
          icon: "icon-xinyongpingjia",
          name: this.$t("Toolbar.CreditAssessment"),
          disabled: true,
        },
        {
          icon: "icon-shujufenxi1",
          name: this.$t("Toolbar.DataAnalysis"),
          disabled: true,
        },
        {
          icon: "icon-touzizuhe",
          name: this.$t("Toolbar.NewPortfolio"),
          disabled: true,
        },
        {
          icon: "icon-dayin-dayinji",
          name: this.$t("Toolbar.Print"),
          disabled: true,
        },
        {
          icon: "icon-gudong",
          name: this.$t("Toolbar.Share"),
          disabled: true,
        },
      ];
    },
    activeTab() {
      return Number(this.$route.query.type || 1);
    },
  },
  components: {
    Header,
    Tollbar,
    Page,
    TabIcon,
    InquiryDialog,
    Background,
    Ownership,
    Investments,
    RelatedCompanies,
    Management,
    SupplyChain,
    UboRuler,
  },
  data() {
    return {
      isShowInquiry: false,
      activeLabelTab: "",
      // activeTab: this.$route.query.tab || "1",
      detailTabs: [
        { name: "Backgroud", type: "1", keyName: "ubo_overview", isShow: true },
        {
          name: "Ownership",
          type: "2",
          keyName: "ubo_ownership",
          isShow: false,
        },
        {
          name: "Investments",
          type: "3",
          keyName: "ubo_investments",
          isShow: false,
        },
        {
          name: "Related Companies",
          type: "4",
          keyName: "ubo_related_companies",
          isShow: false,
        },
        {
          name: "Management",
          type: "5",
          keyName: "ubo_Management",
          isShow: false,
        },
        {
          name: "Supply Chain",
          type: "6",
          keyName: "ubo_supplyChain",
          isShow: false,
        },
        {
          name: "UBO Ruler",
          type: "7",
          keyName: "ubo_ubo_ruler",
          isShow: false,
        },
      ],

      companyInfo: {}, //公司信息
      labelList: [],
      radiusX1: 48,
      radiusX2: 62,
      fontSize: 26,
      lineHeight: 28,
      py: "55%",
      companyDQI: 0, //公司值
      countryDQI: 0, //国家值
      companyChart: null,
      countryChart: null,
    };
  },
  methods: {
    // 搜索
    // 工具栏点击
    onSearch(params, type) {
      // 如果 query 完全一致，直接 return
      let routeData = this.$router.resolve({
        path: "/ubo/list",
        query: {
          keyword: params.searchKeyword,
          selectKey: type,
        },
      });

      window.open(routeData.href, "_blank");
    },
    // 公司信息
    async getCompanyInfo() {
      const id3a = this.$route.query.id3a;
      let res = await getCompanySnap({
        id3a: this.$route.query.id3a,
      });
      if (res.code == 200) {
        this.companyInfo = res.data;
        document.title = this.companyInfo?.base?.companyName;
        let countryImg = this.getCountryImgUrl(res.data?.base?.countryFlag);
        this.companyInfo.base.img = require("../../../static" + countryImg);
        localStorage.setItem("CompanyBase", JSON.stringify(res.data));
        this.labelList = res.data.labels;
        //   公司DQIecahrts
        this.companyDQI =
          res.data.base.companyDQI != "n.a." && res.data.base.companyDQI != "-"
            ? parseInt(res.data.base.companyDQI)
            : 0;
        this.initCompanyEchart();
        // 国家DQIecharts
        this.countryDQI =
          res.data.base.countryDQI && res.data.base.countryDQI != "-"
            ? parseInt(res.data.base.countryDQI)
            : 0;
        this.initCountryEchart();
      }
    },
    // 公司echarts
    initCompanyEchart() {
      this.companyChart = echarts.init(this.$refs.companyRef);
      let data = this.companyDQI;
      let option = {
        title: {
          text: data,
          x: "center",
          y: this.py,
          textStyle: {
            lineHeight: this.lineHeight,
            fontFamily: "Arial Bold",
            fontSize: this.fontSize,
            color: "#FFFFFF",
          },
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: [this.radiusX1, this.radiusX2],
            center: ["50%", "100%"],
            startAngle: 180,
            endAngle: 360,
            label: {
              show: false,
            },
            emphasis: {
              disabled: true, // 关闭高亮（hover 时不变色）
            },
            data: [
              {
                value: data,
                itemStyle: {
                  color:
                    data < 50 ? "#F00000" : data < 76 ? "#FFC000" : "#00c924",
                  borderRadius: data == 100 ? [5, 5, 5, 5] : [5, 0, 5, 0],
                },
              },
              {
                value: 100 - data,
                itemStyle: {
                  color: "#ffffff",
                  borderRadius: data == 0 ? [5, 5, 5, 5] : [0, 5, 0, 5],
                },
              },
            ],
          },
        ],
      };
      this.companyChart.setOption(option);
    },
    // 国家echarts
    initCountryEchart() {
      this.countryChart = echarts.init(this.$refs.countryRef);
      let data = this.countryDQI;
      let option = {
        title: {
          text: data,
          x: "center",
          y: this.py,
          textStyle: {
            lineHeight: this.lineHeight,
            fontFamily: "Arial Bold",
            fontSize: this.fontSize,
            color: "#FFFFFF",
          },
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: [this.radiusX1, this.radiusX2],
            center: ["50%", "100%"],
            startAngle: 180,
            endAngle: 360,
            label: {
              show: false,
            },
            emphasis: {
              disabled: true, // 关闭高亮（hover 时不变色）
            },
            data: [
              {
                value: data,
                itemStyle: {
                  color:
                    data < 50 ? "#F00000" : data < 76 ? "#FFC000" : "#00c924",
                  borderRadius: data == 100 ? [5, 5, 5, 5] : [5, 0, 5, 0],
                },
              },
              {
                value: 100 - data,
                itemStyle: {
                  color: "#ffffff",
                  borderRadius: data == 0 ? [5, 5, 5, 5] : [0, 5, 0, 5],
                },
              },
            ],
          },
        ],
      };
      this.countryChart.setOption(option);
    },
    resizeChart() {
      // 调用 ECharts 实例的 resize 方法，动态调整图表大小
      if (this.companyChart) {
        this.companyChart.resize();
      }
      if (this.countryChart) {
        this.countryChart.resize();
      }
    },
    handleResize() {
      if (window.innerWidth > 1920) {
        // 大屏幕
        this.radiusX1 = 48;
        this.radiusX2 = 62;
        this.fontSize = 26;
        this.lineHeight = 28;
        this.py = "55%";
      } else {
        this.radiusX1 = 32;
        this.radiusX2 = 41;
        this.fontSize = 16;
        this.lineHeight = 18;
        this.py = "52%";
      }
      this.initCompanyEchart();
      this.initCountryEchart();
      this.resizeChart();
    },

    changeTab(index) {
      if (String(this.$route.query.type) === String(index)) return;
      this.isShowInquiry = false;
      // this.activeTab = index;
      this.$router.replace({
        path: "/ubo/detail",
        query: {
          id3a: this.$route.query.id3a,
          keyword: this.$route.query.keyword,
          selectKey: this.$route.query.selectKey,
          type: String(index),
        },
      });
    },
    // 获取tab权限
    async getTabListApi() {
      let res = await getTabListOneLayer({
        aaaId: this.$route.query.id3a,
        moduleType: 12,
      });
      if (res.code == 200) {
        let resTab = res.data || [];
        // let tab1 =
        //   resTab.filter((list) => list.name == "ubo_overview")[0] || {};
        this.detailTabs.forEach((item) => {
          resTab.forEach((list) => {
            if (item.keyName == list.name) {
              item.isShow = list.isShow;
            }
          });
        });
      }
    },
  },
  mounted() {
    this.getTabListApi();
    this.getCompanyInfo().then(() => {
      // tab 左右切换按钮状态 修复 通过监听 tab滑动style变化来触发状态更新***********
      this.$nextTick(() => {
        const nav = this.$el.querySelector(".el-tabs__nav");
        if (!nav) return;
        let syncing = false;
        this.observer = new MutationObserver(() => {
          if (syncing) return;
          syncing = true;
          const cur = this.activeLabelTab;
          this.activeLabelTab = "__temp__";
          this.$nextTick(() => {
            this.activeLabelTab = cur;
            syncing = false;
          });
        });
        this.observer.observe(nav, {
          attributes: true,
          attributeFilter: ["style"],
        });
      });
      // ***********************************************************************
    });

    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);

    // 页面销毁时 解除监听tab切换*************************************************
    this.observer && this.observer.disconnect();
    // *************************************************************************
  },
};
</script>
<style scoped>
.new-content-top-right {
  min-width: 326px;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
.new-content-right-company,
.new-content-right-country {
  width: 124px;
  height: auto;
}
.new-content-right-echart {
  width: 100%;
  height: 62px;
  margin-bottom: 8px;
}
.new-content-right-title {
  display: flex;
  align-items: center;
  line-height: 20px;
  font-size: 16px;
  color: #ffffff;
  white-space: nowrap;
}
.new-content-right-title i {
  margin-left: 6px;
  font-size: 20px;
  color: #ffdb01;
  cursor: pointer;
}

@media (max-width: 1920px) {
  .new-content-top-right {
    margin-top: 7px;
    min-width: 218px;
  }
  .new-content-right-company,
  .new-content-right-country {
    width: 82px;
  }
  .new-content-right-echart {
    height: 42px;
    margin-bottom: 6px;
  }
  .new-content-right-title {
    line-height: 14px;
    font-size: 12px;
  }
  .new-content-right-title i {
    margin-left: 4px;
    font-size: 14px;
  }
  .new-content-detail-wrap {
    top: 168px;
    padding: 0 14px;
  }
}
</style>
